<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/U9Tcrj/tc-custom/9781646685707.jpg?1684306200445" alt="This image is the cover for the book House of Slaughter #1, House of Slaughter"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">House of Slaughter #1, House of Slaughter
      </h1>
      <p class="bookDescription body article font2">
        <p>Discover the inner workings of the House of Slaughter in this new horror series exploring the secret history of the Order that forged Erica Slaughter into the monster hunter she is today. You know Aaron Slaughter as Erica's handler and rival. But before he donned the black mask, Aaron was a teenager training within the House of Slaughter. Surviving within the school is tough enough, but it gets even more complicated when Aaron falls for a mysterious boy destined to be his competition.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James Tynion IV, Werther Dell’Edera, Tate Brombal, Chris Shehan
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      BOOM! Studios
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b786b636